import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from './TopNav';
import Footer from './Footer';
import useSEO from '../hooks/useSEO';

function GetStartedIise2026Page({ logo }) {
  useSEO({
    title: 'IISE 2026 | Veydra',
    description: 'Meet Veydra at IISE 2026 and see decision intelligence in action.'
  });

  return (
    <div className="min-h-screen bg-white">
      <TopNav logo={logo} />

      <main className="max-w-4xl mx-auto px-8 py-20 md:py-28 text-center">
        <p className="text-sm font-medium text-gray-500 uppercase tracking-wider mb-5">
          IISE Annual Conference & Expo 2026
        </p>

        <h1 className="text-4xl md:text-5xl font-medium text-gray-900 mb-6 leading-tight tracking-tight">
          Crash the model, not the business.
        </h1>

        <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-10">
          Veydra.io transforms complex industrial systems into interactive, AI-assisted models.
          Built for modern engineers, our cloud-native Decision Sandbox combines system dynamics and
          discrete-event simulation so ISE teams can quantify uncertainty and see the ripple effects
          of every choice before the stakes are real.
        </p>

        <Link
          to="/book-demo"
          className="inline-block bg-gray-900 text-white text-base md:text-lg font-medium px-8 py-4 rounded-lg hover:bg-gray-800 transition-colors"
        >
          Book Time to Meet at IISE 2026
        </Link>
      </main>

      <Footer />
    </div>
  );
}

export default GetStartedIise2026Page;
